import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

const TermsOfService = () => (
  <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', display: 'flex', flexDirection: 'column' }}>
    <Header />
    <main style={{ padding: '120px 2rem 2rem', maxWidth: 800, margin: '0 auto', width: '100%', boxSizing: 'border-box', flex: 1, textAlign: 'left' }}>
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> May 24, 2025</p>
      <p>These Terms of Service (&quot;Terms&quot;) govern your use of the Bidder iQ Chrome Extension and website (<a href="https://www.bidderiq.com" target="_blank" rel="noopener noreferrer">https://www.bidderiq.com</a>), which are operated by S. Huntley &amp; Co., located at 116 Research Drive, Suite 2214, Bethlehem, PA 18015 (&quot;we&quot;, &quot;our&quot;, &quot;us&quot;).</p>
      <p>By accessing or using our services, you agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, please do not use Bidder iQ.</p>
      <h2>1. Use of the Service</h2>
      <p>Bidder iQ provides live auction analytics overlays through a Chrome Extension and associated website. By using our services, you agree to:</p>
      <ul>
        <li>Only use the extension and website for lawful purposes.</li>
        <li>Not misuse or attempt to interfere with our systems.</li>
        <li>Refrain from reverse engineering or reproducing our code or content.</li>
        <li>You must be 18 years or older to use our services.</li>
      </ul>
      <h2>2. Accounts and Access</h2>
      <p>To access certain features, you must create an account via Clerk, our third-party authentication provider. You are responsible for:</p>
      <ul>
        <li>Maintaining the confidentiality of your login credentials</li>
        <li>All activities that occur under your account</li>
      </ul>
      <p>We reserve the right to suspend or terminate accounts that violate these Terms.</p>
      <h2>3. Payments and Subscriptions</h2>
      <p>Payments for Bidder iQ are processed via Stripe. By subscribing, you agree to the pricing, billing, and refund terms disclosed at checkout. We do not directly store or process your credit card information.</p>
      <h2>4. License and Intellectual Property</h2>
      <p>All content, data, branding, and code associated with Bidder iQ are the intellectual property of S. Huntley &amp; Co.. We grant you a limited, non-exclusive, revocable license to use the service for personal or internal business purposes.</p>
      <p>You may not:</p>
      <ul>
        <li>Copy, modify, or distribute our code or materials</li>
        <li>Use our service in a way that infringes on any third-party rights</li>
      </ul>
      <h2>5. Third-Party Services</h2>
      <p>Bidder iQ interacts with third-party services, including but not limited to:</p>
      <ul>
        <li>Clerk (authentication)</li>
        <li>Stripe (payments)</li>
        <li>Google Sheets (data source for auction listings)</li>
      </ul>
      <p>Your use of these services is subject to their respective terms and privacy policies.</p>
      <h2>6. Disclaimer of Warranties</h2>
      <p>The Bidder iQ service is provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, either express or implied. We do not guarantee:</p>
      <ul>
        <li>Accuracy or availability of auction data</li>
        <li>That the service will be error-free or uninterrupted</li>
        <li>That using Bidder iQ will result in any financial outcome</li>
      </ul>
      <p>Use at your own risk.</p>
      <h2>7. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, S. Huntley &amp; Co. shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service, including but not limited to lost profits or data.</p>
      <p>In no event shall our total liability exceed the amount you paid (if any) for accessing the service in the last 12 months.</p>
      <h2>8. Termination</h2>
      <p>We reserve the right to suspend or terminate your access to Bidder iQ at our sole discretion, with or without notice, if we believe you have violated these Terms.</p>
      <h2>9. User Data and Privacy</h2>
      <p>Your use of our services is subject to our Privacy Policy, which explains how we collect, use, and safeguard your personal data.</p>
      <h2>10. Governing Law</h2>
      <p>These Terms are governed by the laws of the Commonwealth of Pennsylvania, United States. Any legal action related to the use of our services shall be brought exclusively in the state or federal courts located in Pennsylvania.</p>
      <h2>11. Changes to These Terms</h2>
      <p>We may update these Terms periodically. When we do, we will update the effective date at the top of this page. Your continued use of the service after changes means you accept the updated Terms.</p>
      <h2>12. Contact</h2>
      <address>
        <p>S. Huntley &amp; Co.<br />
        116 Research Drive, Suite 2214<br />
        Bethlehem, PA 18015<br />
        <span role="img" aria-label="email">📧</span> <a href="mailto:dwhitlock@shuntley.co">dwhitlock@shuntley.co</a></p>
      </address>
    </main>
    <Footer />
  </div>
);

export default TermsOfService;
